import Axios from "axios";
import { handleApiError } from "./config";

export function listNotifications() {
  return new Promise((resolve, reject) => {
    Axios.get("notification")
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}

export function getNotification(notificationId) {
    return new Promise((resolve, reject) => {
        Axios.get("notification/" + notificationId)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            handleApiError(err)
            return reject(err);
          });
      });
}


export function cancelNotification(notificationId) {
  return new Promise((resolve, reject) => {
    Axios.delete("notification/" + notificationId)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}


export function submitNotification(notification) {
  return new Promise((resolve, reject) => {
      Axios.post("notification/", notification)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          handleApiError(err)
          return reject(err);
        });
    });
}
